// This is not yet a complete store for lab-related state, but it can
// be used to hold lab-specific information that is not available in any
// other existing redux store.  It also holds useful state for newer labs
// that use LabContainer.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit';
import { ProjectManagerStorageType } from './types';
import LabRegistry from './LabRegistry';
import ProjectManagerFactory from './projects/ProjectManagerFactory';
import { setProjectUpdatedAt, setProjectUpdatedError, setProjectUpdatedSaving, setProjectUpdatedSaved, } from '../code-studio/projectRedux';
var initialState = {
    isLoading: false,
    isPageError: false,
    channel: undefined,
    source: undefined,
    labReadyForReload: false,
};
// Thunks
// Set up the project manager for the given level and script,
// then load the project and store the channel and source in redux.
// If we get an aborted signal, we will exit early.
export var setUpForLevel = createAsyncThunk('lab/setUpForLevel', function (payload, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var existingProjectManager, projectManager, projectResponse, _a, source, channel;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                existingProjectManager = LabRegistry.getInstance().getProjectManager();
                // Save any usaved code and clear out any remaining enqueued
                // saves from the existing project manager.
                return [4 /*yield*/, (existingProjectManager === null || existingProjectManager === void 0 ? void 0 : existingProjectManager.cleanUp())];
            case 1:
                // Save any usaved code and clear out any remaining enqueued
                // saves from the existing project manager.
                _b.sent();
                return [4 /*yield*/, ProjectManagerFactory.getProjectManagerForLevel(ProjectManagerStorageType.REMOTE, payload.levelId, payload.scriptId)];
            case 2:
                projectManager = _b.sent();
                // Only set the project manager and initiate load
                // if this request hasn't been cancelled.
                if (thunkAPI.signal.aborted) {
                    return [2 /*return*/];
                }
                LabRegistry.getInstance().setProjectManager(projectManager);
                return [4 /*yield*/, setUpAndLoadProject(projectManager, thunkAPI.dispatch)];
            case 3:
                projectResponse = _b.sent();
                if (!projectResponse.ok) {
                    return [2 /*return*/, thunkAPI.rejectWithValue(projectResponse)];
                }
                return [4 /*yield*/, projectResponse.json()];
            case 4:
                _a = _b.sent(), source = _a.source, channel = _a.channel;
                setProjectData(source, channel, thunkAPI.signal.aborted, thunkAPI.dispatch);
                return [2 /*return*/];
        }
    });
}); });
// Load the project from the existing project manager and store the channel
// and source in redux.
// If we get an aborted signal, we will exit early.
export var loadProject = createAsyncThunk('lab/loadProject', function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var projectManager, projectResponse, _a, source, channel;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                projectManager = LabRegistry.getInstance().getProjectManager();
                if (!projectManager) {
                    return [2 /*return*/, thunkAPI.rejectWithValue('No project manager found.')];
                }
                return [4 /*yield*/, setUpAndLoadProject(projectManager, thunkAPI.dispatch)];
            case 1:
                projectResponse = _b.sent();
                if (!projectResponse.ok) {
                    return [2 /*return*/, thunkAPI.rejectWithValue(projectResponse)];
                }
                return [4 /*yield*/, projectResponse.json()];
            case 2:
                _a = _b.sent(), source = _a.source, channel = _a.channel;
                setProjectData(source, channel, thunkAPI.signal.aborted, thunkAPI.dispatch);
                return [2 /*return*/];
        }
    });
}); });
var labSlice = createSlice({
    name: 'lab',
    initialState: initialState,
    reducers: {
        setIsLoading: function (state, action) {
            state.isLoading = action.payload;
        },
        setIsPageError: function (state, action) {
            state.isPageError = action.payload;
        },
        setChannel: function (state, action) {
            state.channel = action.payload;
        },
        setSource: function (state, action) {
            state.source = action.payload;
        },
        setLabReadyForReload: function (state, action) {
            state.labReadyForReload = action.payload;
        },
    },
    extraReducers: function (builder) {
        builder.addCase(setUpForLevel.fulfilled, function (state) {
            state.isLoading = false;
        });
        builder.addCase(setUpForLevel.rejected, function (state, action) {
            // If the set up was aborted, that means another load got started
            // before we finished. Therefore we only set loading to false if the
            // action was not aborted.
            if (!action.meta.aborted) {
                state.isLoading = false;
            }
        });
        builder.addCase(setUpForLevel.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(loadProject.fulfilled, function (state) {
            state.isLoading = false;
        });
        builder.addCase(loadProject.rejected, function (state, action) {
            // If the set up was aborted, that means another load got started
            // before we finished. Therefore we only set loading to false if the
            // action was not aborted.
            if (!action.meta.aborted) {
                state.isLoading = false;
            }
        });
        builder.addCase(loadProject.pending, function (state) {
            state.isLoading = true;
        });
    },
});
// Helper function to add event listeners to the project manager
// and load the project. Returns the project load response.
// This should be called from a thunk, which will provide its
// thunk dispatch method.
function setUpAndLoadProject(projectManager, dispatch) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    projectManager.addSaveStartListener(function () {
                        return dispatch(setProjectUpdatedSaving());
                    });
                    projectManager.addSaveSuccessListener(function (channel, source) {
                        dispatch(setProjectUpdatedAt(channel.updatedAt));
                        dispatch(setSource(source));
                        dispatch(setChannel(channel));
                    });
                    projectManager.addSaveNoopListener(function (channel) {
                        if (channel) {
                            dispatch(setProjectUpdatedAt(channel.updatedAt));
                            dispatch(setChannel(channel));
                        }
                        else {
                            dispatch(setProjectUpdatedSaved());
                        }
                    });
                    projectManager.addSaveFailListener(function () { return dispatch(setProjectUpdatedError()); });
                    return [4 /*yield*/, projectManager.load()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
// Helper function to set the channel and source in redux.
// If aborted is true, we won't set anything in redux. Once
// we are done, we will mark the lab as ready for reload.
// This should be called from a thunk, which will provide its
// thunk dispatch method.
function setProjectData(source, channel, aborted, dispatch) {
    // Only set channel and sources if the request has not been cancelled.
    if (aborted) {
        return;
    }
    dispatch(setChannel(channel));
    dispatch(setSource(source));
    dispatch(setLabReadyForReload(true));
}
export var setIsLoading = (_a = labSlice.actions, _a.setIsLoading), setIsPageError = _a.setIsPageError, setChannel = _a.setChannel, setSource = _a.setSource, setLabReadyForReload = _a.setLabReadyForReload;
export default labSlice.reducer;
